import { render, staticRenderFns } from "./Remove-Upload.vue?vue&type=template&id=3dd20c4a&scoped=true&"
import script from "./Remove-Upload.vue?vue&type=script&lang=js&"
export * from "./Remove-Upload.vue?vue&type=script&lang=js&"
import style0 from "./Remove-Upload.vue?vue&type=style&index=0&id=3dd20c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd20c4a",
  null
  
)

export default component.exports